import React from 'react';
import PropTypes from 'prop-types';

const FinalPrice = ({
  className, totalPrice, discount, finalPrice,
  giftCardInputTotal, showGiftCardInputTotal, billingPrice,
}) => {

  return (
    <div className={`subscriptionPriceContainer ${className}`}>
      <div className="subscriptionPriceBlock">
        <div className="subscriptionPriceBlockTitle">合計金額</div>
        <div className="boldPrice">{`${totalPrice.toLocaleString()}円`}</div>
      </div>
      <div className="subscriptionPriceBlock">
        <div className="subscriptionPriceBlockTitle">割引金額</div>
        <div className="boldPrice">{`${discount.toLocaleString()}円`}</div>
      </div>
      <div className="subscriptionPriceBlock billing-amount">
        <div className="subscriptionPriceBlockTitle">ご請求金額</div>
        <div className="redPrice">{`${finalPrice.toLocaleString()}円`}</div>
      </div>
      {showGiftCardInputTotal && (
        <div className="subscriptionPriceBlock">
          <div className="subscriptionPriceBlockTitle">日本旅行ギフトカード・<br />ドリーム旅行カード利用額</div>
          <div className="redPrice">{`${giftCardInputTotal.toLocaleString()}円`}</div>
        </div>
      )}
      <div className="subscriptionPriceBlock total">
        <div className="subscriptionPriceBlockTitle">クレジットカード決済金額</div>
        <div className="totalPriceArea">
          {/* <div>税込</div> */}
          <div className="totalPrice">
            {`${billingPrice.toLocaleString()}円`}
          </div>
        </div>
      </div>
      <div className="userInfoCashItemCampaignBillingItemSup">
        領収書の発行について<br />
        PCサイトのマイページにて「領収書自動発行」がご利用いただけます。
      </div>
    </div>
  );
};

FinalPrice.defaultProps = {
  className: '',
  discount: 0,
  giftCardInputUsageAmount: 0,
};

FinalPrice.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  totalPrice: PropTypes.number.isRequired,
  discount: PropTypes.number,
  finalPrice: PropTypes.number.isRequired,
  giftCardInputTotal: PropTypes.number,
  showGiftCardInputTotal: PropTypes.bool.isRequired,
  billingPrice: PropTypes.number.isRequired,
};

export default FinalPrice;
